export const SET_ESTIMATIONS = 'SET_ESTIMATIONS';
export const SET_STEP = 'SET_STEP';
export const SET_CONTAINER_ELEMENT = 'SET_CONTAINER_ELEMENT';
export const SET_RETURN_DATA = 'SET_RETURN_DATA';
export const RESET_RETURN_DATA = 'RESET_RETURN_DATA';
export const SET_RETURN_REASONS = 'SET_RETURN_REASONS';
export const SET_RETURN_RESPONSE_DATA = 'SET_RETURN_RESPONSE_DATA';
export const SET_BOOZTPAY_INVOICE_ID = 'SET_BOOZTPAY_INVOICE_ID';

export const extraFieldConfig = {
    label: 'return_due_to',
    property: 'returnReason',
    valueGetter: product => product.returnReason?.label
};

export const steps = {
    first: 'create_return',
    second: 'overview_of_return',
    third: 'your_return_is_registered'
};
